export default {
  title: "Connect your wallet to continue",
  description:
    "We couldn't automatically connect the wallet linked to your account. Please connect it manually to continue.",
  button: "Connect wallet",
  disconnect: "Back to login",
  disconnectModal: {
    title: "Log out",
    message: "You are about to log out with the email",
    confirm: "Yes, log out",
    cancel: "Cancel",
  },
}
